// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fail {\r\n    font-family: \"BebasNeue-Regular\";\r\n    font-size: 50px;\r\n    text-align: center;\r\n    color:red;\r\n  }", "",{"version":3,"sources":["webpack://src/compPages/LoginPage.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX","sourcesContent":[".fail {\r\n    font-family: \"BebasNeue-Regular\";\r\n    font-size: 50px;\r\n    text-align: center;\r\n    color:red;\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
